import React, { useState } from "react";
import heroBg1 from "../assets/images/hero-bg1.webp";

const Simulation = () => {
  const [formData, setFormData] = useState({
    tipo: "",
    nome: "",
    telefone: "",
    detalhes: "",
  });
  const [success, setSuccess] = useState(false);
  const [telError, setTelError] = useState(false);

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 11)
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(
      7,
      11
    )}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "telefone") {
      const masked = formatPhone(value);
      setFormData((prev) => ({ ...prev, telefone: masked }));
      setTelError(false);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const digits = formData.telefone.replace(/\D/g, "");
    if (digits.length < 10) {
      setTelError(true);
      return;
    }

    const formUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse";

    const formBody = new URLSearchParams({
      "entry.426038373": formData.tipo,
      "entry.371468472": formData.nome,
      "entry.684960318": formData.telefone,
      "entry.697841322": formData.detalhes,
    });

    await fetch(formUrl, {
      method: "POST",
      mode: "no-cors",
      body: formBody,
    });

    setSuccess(true);
    setFormData({ tipo: "", nome: "", telefone: "", detalhes: "" });
    setTelError(false);
  };
  return (
    <>
      {/* Page Header */}
      <section
        className="bg-cover bg-center py-20"
        style={{
          backgroundImage: `radial-gradient(circle, rgba(60, 200, 252, 0.45) 0%, rgba(9, 25, 55, 0.9) 100%), url(${heroBg1})`,
        }}
      >
        <div className="container mx-auto px-4 text-center pt-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Simulação de Seguros
          </h1>
          <p className="text-xl text-white">
            Contrate agora! Personalize conforme suas necessidades
          </p>
        </div>
      </section>

      {/* Simulation Form Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-blue-950 mb-6">
              Solicite aqui!
            </h2>
            <div className="w-20 h-1 bg-orange-500 mb-6"></div>
            <p className="text-gray-700 mb-8">
              Preencha o formulário abaixo com seus dados e necessidades. Nossa
              equipe entrará em contato para apresentar as melhores opções de
              seguros disponíveis para você.
            </p>

            {success ? (
              <p className="text-center text-green-700 font-medium">
                Obrigado! Em breve entraremos em contato.
              </p>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <select
                  name="tipo"
                  value={formData.tipo}
                  onChange={handleChange}
                  required
                  className="w-full appearance-none p-3 pl-5 bg-white border border-gray-300 rounded-2xl text-gray-700 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                >
                  <option value="">Selecione o tipo de seguro</option>
                  <option value="Automovel">Seguro Auto</option>
                  <option value="Saude">Plano de Saúde</option>
                  <option value="Agricola">Seguro Agrícola</option>
                  <option value="Previdencia">Previdência</option>
                  <option value="Vida">Seguro de Vida</option>
                  <option value="Consorcio">Consórcio</option>
                  <option value="Outros">Outros</option>
                </select>

                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  placeholder="Nome Completo"
                  className="w-full p-3 pl-5 border border-gray-300 rounded-2xl text-gray-700 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                />

                <input
                  type="tel"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  required
                  placeholder="Telefone/WhatsApp"
                  className={`w-full p-3 pl-5 border rounded-2xl text-gray-700 placeholder-gray-600 focus:outline-none focus:ring-2 transition ${
                    telError
                      ? "focus:ring-red-500 border-red-500"
                      : "focus:ring-orange-500 border-gray-300"
                  }`}
                />
                {telError && (
                  <p className="text-red-600 text-sm -mt-2">
                    Por favor, insira um telefone válido com DDD.
                  </p>
                )}

                <textarea
                  name="detalhes"
                  value={formData.detalhes}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Informações adicionais (ex: veículo, beneficiários, etc.)"
                  className="w-full p-3 pl-5 border border-gray-300 rounded-2xl text-gray-700 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                />

                <button
                  type="submit"
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white p-3 rounded-2xl font-semibold transition shadow-sm hover:shadow-md"
                >
                  Solicitar Cotação
                </button>
              </form>
            )}

            <div className="mt-12 text-center">
              <p className="text-gray-700 mb-4 font-bold">
                Prefere falar diretamente com um de nossos consultores?
              </p>
              <div className="flex flex-col md:flex-row justify-center gap-4">
                <a
                  href="tel:+553436710349"
                  className="flex items-center justify-center bg-blue-800 hover:bg-blue-900 text-white px-6 py-3 rounded-md font-medium"
                >
                  <i className="fas fa-phone-alt mr-2"></i> Ligar Agora
                </a>
                <a
                  href="https://wa.me/553436710349"
                  className="flex items-center justify-center bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-md font-medium"
                >
                  <i className="fab fa-whatsapp mr-2"></i> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Simulation;
